import _classCallCheck from '/app/node_modules/babel-runtime/helpers/classCallCheck';
import _createClass from '/app/node_modules/babel-runtime/helpers/createClass';
export var CollectorsApi = function () {
  function CollectorsApi(axios) {
    _classCallCheck(this, CollectorsApi);

    this.axios = axios;
  }

  _createClass(CollectorsApi, [{
    key: 'csvModel',
    value: function csvModel(data) {
      return this.axios.$downloadFile('/export-table', data);
    }
  }, {
    key: 'pendingToType',
    value: function pendingToType(data) {
      return this.axios.$downloadFile('/download-pending-to-type', data);
    }
  }, {
    key: 'chargeSellerModel',
    value: function chargeSellerModel() {
      return this.axios.$downloadFile('/download-model-sellers');
    }
  }, {
    key: 'readSellerModel',
    value: function readSellerModel(file) {
      return this.axios.$post('/read-model-sellers', file.file);
    }
  }]);

  return CollectorsApi;
}();


//////////////////
// WEBPACK FOOTER
// ./src/api/collectors.js
// module id = ./src/api/collectors.js
// module chunks = 34